<template>
  <header class="app-header header__shadow">
    <div class="app-header__title">
      <h1>{{ routeLabel }}</h1>
    </div>
    <div class="app-header__tools">
      <!-- Come nel cittadino e nell'operatore: il nome dell'utente in alto a
           destra e l'uscita qui dentro, non piu' in fondo alla navigazione.
           La modale di conferma resta in NavigationAdmin. -->
      <b-dropdown
        id="header-submenu"
        variant="white"
        right
        class="app-header__menu app-header__user"
      >
        <template #button-content>
          <b-avatar
            size="sm"
            variant="secondary"
            :text="userInitials"
            aria-hidden="true"
          ></b-avatar>
          <span
            class="app-header__menu-text"
            :class="{ 'text-capitalize': hasFullName }"
            >{{ welcomeName }}</span
          >
        </template>
        <b-dropdown-item @click.prevent="$bvModal.show('logout-confirm')">
          <b-icon icon="door-open" aria-hidden="true" class="mr-2"></b-icon
          >{{ $t("esci") }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </header>
</template>
<script>
import { mapState } from "vuex";
import { ADMIN_ROUTE_NAMES } from "@/_utils/constants.js";

export default {
  name: "AdminTopHeader",
  computed: {
    ...mapState("utente", ["status", "user"]),
    // Senza anagrafica il ripiego e' lo username, che spesso e' un indirizzo di
    // posta: capitalizzarlo lo renderebbe "Admin@Mail.Com"
    hasFullName() {
      return !!(
        this.user &&
        this.user.anagrafica &&
        (this.user.anagrafica.name || this.user.anagrafica.surname)
      );
    },
    welcomeName() {
      if (this.hasFullName) {
        return [this.user.anagrafica.name, this.user.anagrafica.surname]
          .filter(Boolean)
          .join(" ");
      }
      return this.user ? this.user.username : "";
    },
    // Iniziali per l'avatar nell'header (solo presentazione)
    userInitials() {
      return String(this.welcomeName || "")
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((p) => p.charAt(0))
        .join("")
        .toUpperCase();
    },
    routeLabel() {
      try {
        const entry = this.routeNames[this.$route.name];
        if (!entry) throw "label not found";
        // Rotte con una sezione nel percorso: la chiave e' il parametro
        if (typeof entry === "object") {
          const key = entry[this.$route.params.section] || entry._default;
          if (!key) throw "section label not found";
          return this.$t(key);
        }
        return this.$t(entry);
      } catch (err) {
        return `${this.$t("hello")}, ${this.welcomeName}`;
      }
    },
  },
  data() {
    return {
      routeNames: ADMIN_ROUTE_NAMES,
    };
  },
};
</script>
